import React, { useContext } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import mainLogo from "./img/RatioLogo.svg";
import easyLogo from "./img/EasyGate.svg";
import Login from "./Login/Login";
import { Context } from "./Context.js";
import { useState } from "react";
import { Avatar, Grid } from "@mui/material";

export default function InfoUser() {
  const { nome, setNome, token, setToken } = useContext(Context);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        className="appBar"
        style={{ background: "#5E2367", height: "65px" }}
      >
        <Toolbar
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "65px",
          }}
        >
          <div>
            <img src={easyLogo} width={80} alt="easyLogo" />
            <img src={mainLogo} width={80} alt="logoRatio" />
          </div>
          <Typography variant="h6" component="div" dx={{ flexGrow: 1 }}>
            {nome}
          </Typography>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
